/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
// RSA
// recaptchaEnterpriseSiteKey: '6LfGao8tAAAAAPOkDM6-zdnElYYyFPnkC3BZGkIn',
firebase: {
  apiKey: "AIzaSyBYRfU8OVKSnDgREzw5g4GMHzIBpMw4Fhk",
  authDomain: "rsa-portus.firebaseapp.com",
  projectId: "rsa-portus",
  storageBucket: "rsa-portus.firebasestorage.app",
  messagingSenderId: "10905417423",
  appId: "1:10905417423:web:ab21c30b1c8538d2e5e9ba",
  measurementId: "G-WH50W4FK67"
},


  //  firebase: {
  //  apiKey: "AIzaSyABd1rBgyz8cYmQRCFXifGBedd_m9pvixI",
  //   authDomain: "portuspk.firebaseapp.com",
  //   projectId: "portuspk",
  //   storageBucket: "portuspk.firebasestorage.app",
  //   messagingSenderId: "656828927606",
  //   appId: "1:656828927606:web:81284b765e5307ccf5d957",
  //   measurementId: "G-N7MLMRW7GY"
  // },
  apiBase: "http://localhost:8080",


  // Portus Demo
  // recaptchaEnterpriseSiteKey: '6LdKAmctAAAAAC9M3-FFXE_ZrAcqfMLxPAv7gYmK',

  geonames: {
    username: 'alihaiderkhyraj'   // 👈 aapka username
  }


};
